import { host } from "~/utils/constants";
import {Category} from "~/utils/Category";
import {Article} from "~/utils/Article";
import { useUserDataStorage } from "~/store/userdata";

export class Product {
  id = -1;
  Name = "";
  slug = "";
  Price = 0.0;
  images:{id:number,url:string,rel_url:string,alt:string}[] = []
  Description = "";
  jsonDescription = {}
  categories: Category[] = []
  articles: Article[] = []
  manualUrl: string = ""
  type: "rental"|"sale" = "rental"
  showPrice: "admin"|"customer"|"public" = "admin"
  transparentImage: boolean = true;
  Public:boolean = true;
  badges: {label: string, color: "feature"|"pax"}[] = []
  childProducts: CartProduct[] = []
  related_products: Product[] = []
  setPrice: number = 0

  // Rehydrate a plain object into a Reference instance
  fromJSON(obj: Partial<Product>): Product {
      return Object.assign(new Product(), obj)
  }

  parseJson(ret: { id: number; attributes: { [key: string]: any } }) {
    this.id = ret.id;
    this.Name = ret.attributes.Name;
    this.slug = ret.attributes.slug;
    this.Price = ret.attributes.Price;
    this.Description = ret.attributes.Description;
    this.jsonDescription = ret.attributes.jsonDescription ? ret.attributes.jsonDescription:{};
    this.type = ret.attributes.type ? ret.attributes.type : "rental";
    this.showPrice = ret.attributes.showPrice ? ret.attributes.showPrice : "admin"
    this.transparentImage = ret.attributes.transparentImage != undefined ? ret.attributes.transparentImage : true
    this.Public = ret.attributes.Public != undefined ? ret.attributes.Public : true
    this.badges = ret.attributes.badges ? ret.attributes.badges : []
    if(!this.Public && !this.badges.find((badge)=>badge.label == "Nicht öffentlich")){
      this.badges.push({label:"Nicht öffentlich", color:"feature"})
    }
    if(this.type == "sale" && !this.badges.find((badge)=>badge.label == "Verkauf")){
      this.badges.push({label:"Verkauf", color:"feature"})
    }
    this.setPrice = ret.attributes.setPrice ? ret.attributes.setPrice : 0
    if(ret.attributes.Images){
      this.images = []
      if(ret.attributes.Images.data){
        ret.attributes.Images.data.forEach((image:any) => {
          const tempImage = {
              url: host+image.attributes.url,
              rel_url: image.attributes.url,
              id: image.id,
              alt: image.attributes.alternativeText
          };
          
          this.images.push(tempImage);
        });
      }
      else{
        this.images.push({
          id:0, 
          alt:"",
          rel_url:"/uploads/wp_content_uploads_woocommerce_placeholder_200x200_b408feaf06_e439d49102.png",
          url:host + "/uploads/wp_content_uploads_woocommerce_placeholder_200x200_b408feaf06_e439d49102.png"})
      }
    }
    if(ret.attributes.categories){
      this.categories = []
      ret.attributes.categories.data.forEach((category:any) => {
        const tempCategory = new Category()
        tempCategory.parseJson(category)
        this.categories.push(tempCategory);
      });
    }
    if(ret.attributes.articles){
      this.articles = []
      ret.attributes.articles.data.forEach((article:any) => {
        const tempArticle = new Article()
        tempArticle.parseJson(article)
        this.articles.push(tempArticle);
      });
    }
    if(ret.attributes.childProducts){
      this.childProducts = ret.attributes.childProducts.map((product:any):CartProduct=>{
        const tempProduct = new Product()
        tempProduct.parseJson(product.product.data)
        
        return{
          ...product,
          count: product.Anzahl,
          product: tempProduct
        }
      })
    }
    if(ret.attributes.related_products){
      this.related_products = ret.attributes.related_products.data.map((product:any):Product=>{
        const tempProduct = new Product()
        tempProduct.parseJson(product)
        
        return tempProduct
      })
    }
    if(ret.attributes.manual && ret.attributes.manual.data){
      this.manualUrl = host + ret.attributes.manual.data.attributes.url
    }
  }
  toJSON () {
    const retValue = {...this}
    const optimizedCategories:{id:number, name:String,slug:string}[] = []
    if(retValue.categories){
      retValue.categories.forEach((category)=>{
        optimizedCategories.push({
          "id":category.id,
          "name":category.name,
          "slug":category.slug
        })
      })
    }
    retValue.categories = optimizedCategories as Category[]
    retValue.articles = []
    this.articles.forEach((article)=>{
       retValue.articles.push(new Article().fromJSON(article).toJSON())
    })

    retValue.childProducts = this.childProducts.map((product)=>{
      return {
        ...product,
         product:product.product.toJSON()
      }
    })

    retValue.related_products = this.related_products.map((product)=>{
      return product.toJSON()
    })
    return retValue
  }


  toApiJSON(){
      const Images:Number[] = []
      if(this.images.length > 0){
        this.images.forEach((image)=>{
          if(image.id){
            Images.push(image.id)
          }
        })
      }
      return {
          ...this,
          images: null,
          Images: Images,
          childProducts: this.childProducts.map((product:CartProduct)=>{
            return{
              ...product,
              Anzahl: product.count,
              product: product.product
            }
          })
      } // here I make a POJO's copy of the class instance
  }
}

export function isPriceOfProductVisible(product:Product){
  let priceVisible = false
  const userDataStorage = useUserDataStorage()

  if(userDataStorage.user){
    if(userDataStorage.user.role.name == "Authenticated"){
      priceVisible = true
    }
    if(userDataStorage.user.role.name == "Customer" && product.showPrice == "customer"){
      priceVisible = true
    }
  }
  if(product.showPrice == "public"){
    priceVisible = true
  }

  return priceVisible
}
